import { FC } from 'react';
import classNames from 'classnames';
import { Typography } from '@mui/material';
import { IconQuestion } from 'components/Icons/IconQuestion';
import Tooltip from 'components/common/Tooltip/Tooltip';
import cls from './styles.module.scss';

export interface TitleWithTooltipProps {
	title: string;
	tooltipTitle?: string;
	theme: 'gray' | 'black';
	size: 'lg' | 'md' | 'xs';
	rootClassName?: string;
	isRequired?: boolean;
}

const TitleWithTooltip: FC<TitleWithTooltipProps> = ({
	title,
	tooltipTitle,
	theme,
	size,
	rootClassName,
	isRequired,
}) => (
	<div className={classNames(cls.root, rootClassName)}>
		<Typography className={`${cls.text} ${cls[theme]} ${cls[size]}`}>{title}</Typography>
		{isRequired && <span>*</span>}

		{tooltipTitle && (
			<Tooltip title={tooltipTitle} placement="top">
				<IconQuestion />
			</Tooltip>
		)}
	</div>
);

export default TitleWithTooltip;
